export default "__VITE_ASSET__DzOaBxy0__"